import React from "react";
import Container from "react-bootstrap/Container";
import BreadCrumb from "../../../components/organisms/Breadcrumb/BreadCrumb";
import Headline from "../../../components/organisms/Headline/Headline";

const AllUsers = () => {
  return (
    <Container fluid className="layout-bar">
      <BreadCrumb />
      <Headline />
    </Container>
  );
};

export default AllUsers;
